import { render, staticRenderFns } from "./PaymentSetting.vue?vue&type=template&id=78c518c9&"
import script from "./PaymentSetting.vue?vue&type=script&lang=ts&"
export * from "./PaymentSetting.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports